import { render, staticRenderFns } from "./FilterDrawerShell.vue?vue&type=template&id=12b89c83"
import script from "./FilterDrawerShell.vue?vue&type=script&lang=js"
export * from "./FilterDrawerShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports